//TODO : Refactor after ai
import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

export interface ObjectDetailLayoutProps extends HTMLAttributes<HTMLDivElement> {
  header?: ReactNode;
  /** Left column: the x:n collections you work through. */
  relations?: ReactNode;
  /** Right column: the x:1 records this object points at, then its attributes. */
  aside?: ReactNode;
  maxWidth?: number | string;
  style?: CSSProperties;
}

/** Two-column object detail page: x:n relations left, x:1 and attributes right. */
export function ObjectDetailLayout({
  header,
  relations,
  aside,
  maxWidth,
  className = "",
  style,
  ...rest
}: ObjectDetailLayoutProps) {
  return (
    <div
      className={className}
      style={{
        maxWidth,
        margin: maxWidth ? "0 auto" : undefined,
        display: "flex",
        flexDirection: "column",
        gap: 20,
        ...style,
      }}
      {...rest}
    >
      {header}
      <div className="bui-obj-detail">
        <div className="bui-obj-detail__col">{relations}</div>
        <div className="bui-obj-detail__col">{aside}</div>
      </div>
    </div>
  );
}
